<script setup lang="ts">
/**
 * Bannière d'erreur de commande (paiement / serveur), avec bouton fermer.
 * Partagé entre /a/[slug] et /b/[slug] (step Récapitulatif).
 */
defineProps<{
  error: string;
  technical: boolean;
  contactEmail?: string | null;
}>();

defineEmits<{
  (e: 'clear'): void;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl">
    <div class="flex items-start gap-3">
      <UIcon
        :name="technical ? 'i-lucide-server-crash' : 'i-lucide-alert-circle'"
        class="size-5 text-red-600 shrink-0 mt-0.5"
      />
      <div class="flex-1 min-w-0">
        <p class="text-sm font-semibold text-red-800 dark:text-red-300">
          {{ technical ? t("association.publicPage.orderErrorBanner.paiementNonAbouti") : t("association.publicPage.orderErrorBanner.paiementImpossible") }}
        </p>
        <p class="text-sm text-red-700 dark:text-red-400 mt-0.5 break-words">
          {{ error }}
        </p>
        <i18n-t
          v-if="technical && contactEmail"
          keypath="association.publicPage.orderErrorBanner.contactezNous"
          tag="p"
          class="text-xs text-red-600 dark:text-red-400 mt-1.5"
        >
          <template #email>
            <a :href="`mailto:${contactEmail}`" class="font-semibold underline">{{ contactEmail }}</a>
          </template>
        </i18n-t>
        <button class="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-white bg-red-600 hover:bg-red-700 transition-colors" @click="$emit('clear')">
          <UIcon name="i-lucide-x" class="size-3.5" />
          {{ t("association.publicPage.orderErrorBanner.fermer") }}
        </button>
      </div>
    </div>
  </div>
</template>
